document.addEventListener(
  'click',
  (event) => {
    const trigger = event.target.closest('[data-localization-country-trigger]');
    if (!trigger) return;

    const popover = document.getElementById(trigger.getAttribute('aria-controls'));
    const list = popover?.querySelector('[data-localization-country-list]');
    if (!list || list.dataset.populated) return;

    const countries = window.themeVariables?.localization?.countries || [];
    const currentCode = list.dataset.currentCountry;
    const fragment = document.createDocumentFragment();

    countries.forEach((country) => {
      const isSelected = country.code === currentCode;

      const option = document.createElement('button');
      option.type = 'submit';
      option.name = 'country_code';
      option.className = 'popover__value-option h-stack gap-2.5';
      option.setAttribute('role', 'option');
      option.value = country.code;
      option.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      option.textContent = `${country.name} (${country.currencyCode}${country.currencySymbol ? ' ' + country.currencySymbol : ''})`;

      fragment.appendChild(option);
    });

    list.appendChild(fragment);
    list.dataset.populated = 'true';
  },
  true
);
